import React from "react";

export type CovidLoaderProps = {};

const CovidLoader: React.FC<CovidLoaderProps> = () => {
  return <div>Loading...</div>;
};

export default CovidLoader;
